<!-- <div class="timeline-container">
	<div class="timeline-arrow">
		<div *ngFor="let step of steps; let i = index" class="step-container">
			<div *ngIf="!step.skipped" class="step" [class.arrow-approved]="step.step_status === 'approved'"
				[class.active]="activeIndex === step.code" [class.completed]="isStepCompleted(step)"
				(click)="onActiveIndexChange(step)">

				<div class="step-indicator">
					<span class="step-number">{{ getStepNumber(step) }}</span>
				</div>
				<span class="step-label">{{ step.name }}</span>

				<div class="step-arrow" *ngIf="i < steps.length - 1"></div>
			</div>
		</div>
	</div>
</div> -->

<div class="card">
  <div class="timeline-stepper-container mt-3">
    <!-- Left Arrow -->
    <button
      class="fetch-data-btn mx-3"
      (click)="navigate(-1)"
      [disabled]="currentIndex === 0"
    >
      ‹ Prev
    </button>

    <!-- Timeline -->
    <div class="timeline-stepper-wrapper">
      <div class="timeline-stepper">
        <ng-container *ngFor="let step of visibleSteps; let i = index">
          <!-- Step Item -->
          <div class="timeline-stepper-item">
            <div
              class="timeline-stepper-circle"
              [class.timeline-stepper-current]="isCurrent(step)"
              [class.timeline-stepper-approved]="
                step.step_status === 'approved'
              "
              (click)="onActiveIndexChange(step)"
            >
              <span *ngIf="step.step_status === 'approved'">✔</span>
              <span *ngIf="step.step_status !== 'approved'">{{
                getStepNumber(step)
              }}</span>
            </div>

            <div class="timeline-stepper-label">{{ step.name }}</div>
          </div>

          <!-- Connector (only between real steps) -->
          <div
            *ngIf="i < visibleSteps.length - 1"
            class="timeline-stepper-connector"
            [class.timeline-stepper-connector-completed]="isStepCompleted(step)"
          ></div>
        </ng-container>
      </div>
    </div>

    <!-- Right Arrow -->
    <button
      class="fetch-data-btn mx-3"
      (click)="navigate(1)"
      [disabled]="currentIndex >= filteredSteps.length - 1"
    >
      Next ›
    </button>
  </div>

  <hr class="my-3" />
  <div class="route-list-container">
    <!-- <div class="card"> -->
    <!-- <ng-container *ngIf="filteredRouteList?.length > 0; else emptyTemplate">
                <div class="route-track" [class.single-item]="filteredRouteList.length === 1">
                    <div class="route-item" *ngFor="let member of filteredRouteList; let i = index; let last = last">
                      
                        <div class="step-dot" [class.active-dot]="isInProgressPath(member , i)"
                            [class.inactive-dot]="!isInProgressPath(member , i)">
                        </div>

                
                        <div class="step-connector" [class.active-connector]="isConnectorActive(i)"
                            [class.inactive-connector]="!isConnectorActive(i)" *ngIf="!last">
                        </div>

                        <div class="user-info">
                            <span class="user-name">{{member.user.loginname}}</span>
                            <span class="user-role">
                                {{member.user.rankName}} {{member.user.first_name}} {{member.user.last_name}}
                            </span><br>
                            <span class="user-role">Designation : {{member.user.hrcdf_designation}}</span><br>
                            <span class="user-role">Directorate : {{member.user.unit.name}}</span><br>
                            <span class="user-role">Role : {{member.role.name}}</span>
                        </div>
                    </div>
                </div>
            </ng-container> -->

    <div class="mx-auto overflow-auto pb-5">
      <div
        class="d-flex flex-nowrap align-items-start gap-5 px-3 timeline-container"
      >
        <div
          *ngFor="let item of timelineData; let i = index"
          class="d-flex flex-column align-items-center position-relative timeline-item"
        >
          <div
            class="position-relative d-flex justify-content-center align-items-center timeline-node transition"
            [ngClass]="{
              'timeline-node-animated': animatedNodes.has(item.id),
              'timeline-node-selected': selectedNode?.id === item.id
            }"
            (click)="handleNodeClick(item)"
          >
            <div
              class="rounded-3 border border-4 d-flex align-items-center justify-content-center cursor-pointer p-3 shadow transition"
              [ngClass]="getStatusColorClass(item.status, item.userType)"
            >
              <i
                [class]="getStatusIconClass(item.status) + ' text-white fs-5'"
              ></i>
            </div>

            <span
              *ngIf="item.priority"
              class="position-absolute badge rounded-pill top-0 end-0 translate-middle-y fw-bold shadow-sm"
              [ngClass]="getPriorityColorClass(item.priority)"
            >
              {{ item.priority.toUpperCase() }}
            </span>

            <div *ngIf="item.status === 'working'" class="working-pulse"></div>
          </div>

          <div
            [class]="getConnectorClass(item.status, i, timelineData.length)"
          ></div>

        <div class="card timeline-card mt-4 border-0 rounded-4 shadow-lg"  [ngClass]="{
    'card-selected': selectedNode?.id == item.id,
    'expanded': expandedItems[item.id]
  }"style="width: 300px;">
          
          <div class="card-header bg-white p-0 border-0">
            <button
              type="button"
              class="btn btn-light w-100 p-4 text-start transition"
              (click)="toggleExpanded(item.id)"
            >
              <div class="d-flex align-items-center justify-content-between">
                <div class="flex-grow-1">
                  <h3 class="h5 fw-bold text-dark mb-2 line-height-tight">
                    {{ item.unit }}
                  </h3>
				  <p>{{item.name}}</p>
                  
                  <div class="d-flex align-items-center justify-content-between gap-3">
                    <span class="badge rounded-pill fw-semibold py-1 px-3" [ngClass]="getStatusBadgeColorClass(item.status)">
                      <i [class]="getStatusIconClass(item.status) + ' me-1 fs-6'"></i> {{ item.status === 'working' ? 'In Progress' : (item.status | titlecase) }}
                    </span>
                    
                    <div class="d-flex align-items-center gap-1 text-sm text-secondary">
                      <i class="pi pi-calendar text-muted fs-6"></i> <span>{{ formatTimestamp(item.timestamp) }}</span>
                    </div>
                  </div>
                </div>
                
                <div class="ms-3">
                  <i class="pi" 
                     [ngClass]="{'pi-chevron-down': !expandedItems[item.id], 'pi-chevron-up': expandedItems[item.id]}"></i>
                </div>
              </div>
            </button>
          </div>

          <div class="collapse transition" [ngClass]="{'show': expandedItems[item.id]}">
            <div class="card-body p-4 pt-2 border-top border-light">

              <!-- <p class="text-secondary small">{{item.description}}</p> -->

              <div *ngIf="item.hasInternal && item.internalUsers" class="mt-3">
                <div class="d-flex align-items-center gap-2 mb-3">
                  <i class="pi pi-users text-primary fs-6"></i> <h4 class="fw-semibold text-dark small mb-0">Internal Team Members</h4>
                </div>
                
                <div class="d-grid gap-2">
                  <div 
                    *ngFor="let internalUser of item.internalUsers; let internalIndex = index" 
                    class="d-flex align-items-center justify-content-between bg-light rounded-3 p-3 border border-light"
                  >
                    <div class="d-flex align-items-center gap-3 flex-grow-1">
                      <div class="me-2">
                        <i [class]="getStatusIconClass(internalUser.status)" [ngClass]="{'text-success': internalUser.status === 'completed', 'text-primary': internalUser.status === 'working', 'text-secondary': internalUser.status === 'pending'}"></i>
                      </div>
                      <div class="flex-grow-1">
                        <p class="fw-medium text-dark small mb-0">
                          {{ internalUser.name }}
                        </p>
						 <p class="fw-medium text-dark small mb-0">
                          {{ internalUser.permission | titlecase }}
                        </p>
                      </div>
                      <span class="badge rounded-pill py-1 px-2 small" [ngClass]="getStatusBadgeColorClass(internalUser.status)">
                        {{ internalUser.status === 'working' ? 'In Progress' : (internalUser.status | titlecase) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedNode" class="modal fade show d-block modal-backdrop-custom" tabindex="-1" aria-labelledby="nodeDetailModalLabel" aria-modal="true" role="dialog">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content rounded-4 shadow-lg">
        <div class="modal-header border-0 pb-0">
          <h3 class="modal-title fs-5 fw-bold text-dark" id="nodeDetailModalLabel">
            {{ selectedNode.name }}
          </h3>
          <button 
            type="button" 
            class="btn-close" 
            aria-label="Close"
            (click)="closeModal()"
          ></button>
        </div>
        <div class="modal-body pt-2">
          <div class="d-grid gap-2">
            <p class="text-secondary">{{ selectedNode.description }}</p>
            <div class="d-flex align-items-center gap-2">
              <span class="fw-medium">Status:</span>
              <span class="badge rounded-pill fw-medium py-1 px-3" [ngClass]="getStatusBadgeColorClass(selectedNode.status)">
                {{ selectedNode.status | titlecase }}
              </span>
            </div>
            <div class="d-flex align-items-center gap-2">
              <span class="fw-medium">Priority:</span>
              <span class="badge rounded-pill fw-bold py-1 px-3" [ngClass]="getPriorityColorClass(selectedNode.priority)">
                {{ selectedNode.priority?.toUpperCase() }}
              </span>
            </div>
            <div *ngIf="selectedNode.duration" class="d-flex align-items-center gap-2">
              <span class="fw-medium">Duration:</span>
              <span>{{ selectedNode.duration }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
			
			<ng-template #emptyTemplate>
                <div class="route-track empty-track">
                    <div class="empty-message">
                        No users in the route list
                    </div>
                </div>
            </ng-template>
            <div class="d-flex justify-content-end my-3 mx-3"
               >
                <!-- <button class="fetch-data-btn mt-3 h-35px" (click)="editeRoute()">
                    <i class="pi pi-users me-2"></i>
                    Edit Route Config
                </button> -->
      <button class="fetch-data-btn" (click)="openDialog()">
        Open Share Dialog
      </button>
    </div>
  </div>
  <!-- </div> -->
</div>
<!-- <div class="timeline-container">
  <div class="timeline-arrow">
    <div *ngFor="let step of steps; let i = index" class="step-container">
      <div *ngIf="!step.skipped"
           class="step" [class.arrow-approved]="step.step_status === 'approved'"
           [class.active]="activeIndex === step.code"
           [class.completed]="isStepCompleted(step)"
           [class.disabled]="!canNavigateTo(step)"
           (click)="onStepClick(step)">
           
        <div class="step-indicator">
          <span class="step-number">{{ getStepNumber(step) }}</span>
        </div>
        <span class="step-label">{{ step.name }}</span>

        <div class="step-arrow" *ngIf="i < steps.length - 1"></div>
      </div>
    </div>
  </div>
</div> -->
<!-- <div>
	<div>
		<div class="timeline-cover text-center">
			<ul class="timeline">
				<li *ngFor="let step of routeList; let i = index" class="" [ngClass]="{'active': i === 0}">
					<label>{{step.user_role }}</label> <br>
					<label>({{ step.user_directorate_unit }})</label>
				</li>
			</ul>
		</div>
	</div>

</div> -->
<div class="container-fluid">
  <!-- <div class="route-list-container mt-3">
		<div class="card">
			<ng-container *ngIf="filteredRouteList?.length > 0; else emptyTemplate">
				<div class="route-track" [class.single-item]="filteredRouteList.length === 1">
					<div class="route-item" *ngFor="let member of filteredRouteList; let i = index; let last = last">
					
						<div class="step-dot" [class.active-dot]="isInProgressPath(member , i)"
							[class.inactive-dot]="!isInProgressPath(member , i)">
						</div>

						<div class="step-connector" [class.active-connector]="isConnectorActive(i)"
							[class.inactive-connector]="!isConnectorActive(i)" *ngIf="!last">
						</div>

						<div class="user-info">
                            <span class="user-name">{{member.user.loginname}}</span>
							<span class="user-role">
							{{member.user.rankName}} {{member.user.first_name}} {{member.user.last_name}}
							</span><br>
                            <span class="user-role">Designation : {{member.user.hrcdf_designation}}</span><br>
                            <span class="user-role">Directorate : {{member.user.unit.name}}</span><br>
							<span class="user-role">Role : {{member.role.name}}</span>
						</div>
					</div>
				</div>
			</ng-container>

			<ng-template #emptyTemplate>
				<div class="route-track empty-track">
					<div class="empty-message">
						No users in the route list
					</div>
				</div>
			</ng-template>
			<div class="d-flex justify-content-end"
				*ngIf="step_details?.is_initiator || step_details?.is_recommender || userID == '6'">
				<button class="fetch-data-btn mt-3 h-35px" (click)="editeRoute()">
					<i class="pi pi-users me-2"></i>
					Edit Route Config
				</button>
			</div>
		</div>
	</div> -->

  <div>
    <div class="custom-tab-container">
      <div
        class="custom-tab"
        (click)="onUserGuide('process')"
        [ngClass]="{ 'active-tab': userGuide === 'process' }"
      >
        Process Flow
      </div>
      <div
        class="custom-tab"
        (click)="onUserGuide('user')"
        [ngClass]="{ 'active-tab': userGuide === 'user' }"
      >
        User Hierarchy
      </div>
      <div
        class="custom-tab"
        (click)="onUserGuide('comments')"
        [ngClass]="{ 'active-tab': userGuide === 'comments' }"
      >
        Comments History
      </div>
      <div
        class="custom-tab"
        (click)="onUserGuide('report'); getReportList(); getDocumentList()"
        [ngClass]="{ 'active-tab': userGuide === 'report' }"
      >
        <!-- Report Version -->
        Documents & Reports
      </div>
    </div>

    <div class="tab-content">
      <div
        *ngIf="
          userGuide !== 'comments' &&
          userGuide !== 'report' &&
          userGuide != 'user'
        "
      >
        <div class="row p-0">
          <div class="card pb-5" *ngIf="stapName">
            <ng-container *ngIf="activeIndex == 'R-ND'">
              <app-need-genration
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'/revenue/need-generation/?proposal_step='"
                [postUrl]="'/revenue/need-generation/'"
                (generatePDFEmitter)="generatePDF($event)"
                (IRA)="onIRA($event)"
                (stepCompleted)="goToNextStep()"
                (view_sign)="viewSignature()"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
                [schemeType]="'rev'"
              ></app-need-genration>
            </ng-container>
            <ng-container *ngIf="activeIndex == 'makeI_02'">
              <app-need-genration
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'/revenue/approval/need-generation/?proposal_step='"
                [postUrl]="'/revenue/approval/need-generation/'"
                (generatePDFEmitter)="generatePDF($event)"
                (IRA)="onIRA($event)"
                (stepCompleted)="goToNextStep()"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
                [type]="'approval'"
                [schemeType]="'rev'"
              ></app-need-genration>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'R-FSOTR'">
              <app-sotr
                [id]="stapName.id"
                [heading]="'Formulation of SOTRs'"
                [getUrl]="'/revenue/sotr-details/?proposal_step='"
                [postUrl]="'/revenue/sotr-details/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
              ></app-sotr>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-IP'">
              <app-initiation-of-proposal
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'/revenue/initiation-of-proposal/?proposal_step='"
                [postUrl]="'/revenue/initiation-of-proposal/'"
                (generatePDFEmitter)="generatePDF($event)"
                
                
                [stepDetails]="step_details"
              ></app-initiation-of-proposal>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-AIP'">
              <app-aip
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'/revenue/aip-details/?proposal_step='"
                [postUrl]="'/revenue/aip-details/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-aip>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'R-NOQA'">
              <app-nomination-of-qa-agency
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'/revenue/nomination-qa/?proposal_step='"
                [postUrl]="'/revenue/nomination-qa/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-nomination-of-qa-agency>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-VI'">
              <app-vendor
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-vendor>
              <!-- <app-revenue-vendors [proposalName]="proposalName" [proposalId]="proposalId" [step]="stapName"
                                (generatePDFEmitter)="generatePDF($event)" [schemeType]="'idex'" [id]="stapName.id"
                                (stepCompleted)="goToNextStep()" (IRA)="onIRA($event)" [isEditable]="isEditable"
                                [stepDetails]="step_details"></app-revenue-vendors> -->
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-EoI'">
              <app-eoi
                [id]="stapName.id"
                [step]="stapName"
                [getUrl1]="'/revenue/eol-details/?proposal_step='"
                [postUrl1]="'/revenue/eol-details/'"
                (generatePDFEmitter)="generatePDF($event)"
                [masterData]="MasterData"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              >
              </app-eoi>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'R-UEOID'">
              <app-upload-doc
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-upload-doc>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-SLV'">
              <app-shortlisting-vendors
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-shortlisting-vendors>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-RFP-SOC'">
              <!-- <app-rfp [id]="stapName.id" [step]="stapName"
								[getUrl]="'/revenue/rfp-details/?proposal_step='" [postUrl]="'/revenue/rfp-details/'"
								(generatePDFEmitter)="generatePDF($event)"></app-rfp> -->
              <app-idex-rfp-soc
                (generatePDFEmitter)="generatePDF($event)"
                [proposalName]="proposalName"
                [masterData]="MasterData"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'revenue'"
                (pocRequiredChanged)="handlePOCChange($event)"
                [stepDetails]="step_details"
              ></app-idex-rfp-soc>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-AoN'">
              <app-aon
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-aon>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'RFP-V'">
              <app-pre-rfp-meeting
                [id]="stapName.id"
                [step]="stapName"
                [isEditable]="isEditable"
                [getUrl]="'revenue/pre-rfp-meeting/'"
                [postUrl]="'revenue/pre-rfp-meeting/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [stepDetails]="step_details"
                [schemeType]="'rev'"
              ></app-pre-rfp-meeting>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-FS'">
              <app-freeze-sotr
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/freeze-sotr/'"
                [postUrl]="'revenue/freeze-sotr/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-freeze-sotr>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'I-RFP'">
              <app-idex-commercial-rfp
                [id]="stapName.id"
                [step]="stapName"
                [proposalName]="proposalName"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-idex-commercial-rfp>
            </ng-container>

            <ng-container *ngIf="activeIndex == 'R-MCommittee'">
              <app-constitute-committee
                [id]="stapName.id"
                [step]="stapName"
                [title]="'Constitute TOC, TEC, TNC, PC'"
                (stepCompleted)="goToNextStep()"
                [getUrl]="'revenue/constitute-committee/'"
                (IRA)="onIRA($event)"
                [postUrl]="'revenue/constitute-committee/'"
                (generatePDFEmitter)="generatePDF($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-constitute-committee>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-PBC'">
              <app-pre-bid
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/pre-bid/'"
                [postUrl]="'revenue/pre-bid/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-pre-bid>
            </ng-container>

            <!-- <ng-container *ngIf="activeIndex === 'R-TO&RFP'">
							<app-tender-opening [id]="stapName.id" [step]="stapName"
								[getUrl]="'revenue/tender-opening/'" [postUrl]="'revenue/tender-opening/'"
								(generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
								(IRA)="onIRA($event)" [isEditable]="isEditable"
								[stepDetails]="step_details"></app-tender-opening>
						</ng-container> -->

            <ng-container *ngIf="activeIndex == 'R-TO&RFP'">
              <app-revenue-bid
                (generatePDFEmitter)="generatePDF($event)"
                [id]="stapName.id"
                [proposalName]="proposalName"
                [proposalId]="proposalId"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-revenue-bid>
            </ng-container>

            <ng-container *ngIf="activeIndex == 'R-TEC'">
              <app-revenue-bid
                (generatePDFEmitter)="generatePDF($event)"
                [id]="stapName.id"
                [proposalName]="proposalName"
                [proposalId]="proposalId"
                [format]="'upload'"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-revenue-bid>
            </ng-container>

            <!-- 
						<ng-container *ngIf="activeIndex === 'R-TEC'">
							<app-technical-eveluation [id]="stapName.id" [step]="stapName"
								(generatePDFEmitter)="generatePDF($event)" (stepCompleted)="goToNextStep()"
								(IRA)="onIRA($event)" [isEditable]="isEditable" 
								[stepDetails]="step_details"></app-technical-eveluation>
						</ng-container> -->
            <ng-container *ngIf="activeIndex === 'R-POC'">
              <app-revenue-poc
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-revenue-poc>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'R-TN'">
              <app-technical-negotiations
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                [getUrl]="'revenue/technical-negotiations/'"
                (IRA)="onIRA($event)"
                [postUrl]="'revenue/technical-negotiations/'"
                (generatePDFEmitter)="generatePDF($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-technical-negotiations>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-BM'">
              <app-banchmark
                [id]="stapName.id"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                (generatePDFEmitter)="generatePDF($event)"
                [stepDetails]="step_details"
              ></app-banchmark>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'Q-CST'">
              <app-commercial-evaluation
                [id]="stapName.id"
                [step]="stapName"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-commercial-evaluation>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-CN'">
              <app-commercial-negocatition
                [id]="stapName.id"
                (IRA)="onIRA($event)"
                [step]="stapName"
                (stepCompleted)="goToNextStep()"
                [isEditable]="isEditable"
                (generatePDFEmitter)="generatePDF($event)"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-commercial-negocatition>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-FO'">
              <app-final-offer
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/final-offer/'"
                [postUrl]="'revenue/final-offer/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
                [schemeType]="'rev'"
              ></app-final-offer>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'R-PSO'">
              <app-sanction-order
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/sanction-order/'"
                [postUrl]="'revenue/sanction-order/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-sanction-order>
            </ng-container>

            <!-- Prototype phase -->
            <ng-container *ngIf="activeIndex === 'R-KM'">
              <app-nominate-directorate
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'/revenue/nominate/steering/?proposal_step='"
                [postUrl]="'/revenue/nominate/steering/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-nominate-directorate>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'tdf_005'">
              <app-constitute-committee
                [id]="stapName.id"
                [step]="stapName"
                [title]="'Constitute   Committee'"
                [getUrl]="'revenue/constitute-committee/'"
                [postUrl]="'revenue/constitute-committee/'"
                (IRA)="onIRA($event)"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-constitute-committee>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'Rev_011'">
              <app-upload-drawings
                [id]="stapName.id"
                [step]="stapName"
                (IRA)="onIRA($event)"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-upload-drawings>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'Rev_012'">
              <app-upload-qap-atp
                [id]="stapName.id"
                [step]="stapName"
                (IRA)="onIRA($event)"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-upload-qap-atp>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'idex_007'">
              <app-idex-prototype
                [proposalName]="proposalName"
                [proposalId]="proposalId"
                [step]="stapName"
                (generatePDFEmitter)="generatePDF($event)"
                [schemeType]="'revenue'"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-idex-prototype>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'Rev_017'">
              <app-upload-fats
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/final-offer/'"
                [postUrl]="'revenue/final-offer/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-upload-fats>
            </ng-container>

            <ng-container *ngIf="activeIndex === 'Rev_013'">
              <app-idex-utrr
                (generatePDFEmitter)="generatePDF($event)"
                [step]="stapName"
                [schemeType]="'revenue'"
                [id]="stapName.id"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [schemeType]="'rev'"
                [stepDetails]="step_details"
              ></app-idex-utrr>
            </ng-container>
            <ng-container *ngIf="activeIndex === 'Rev_014'">
              <app-user-certificate
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/final-offer/'"
                [postUrl]="'revenue/final-offer/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
              ></app-user-certificate>
            </ng-container>

            <!-- Bulk phase -->
            <!-- <ng-container *ngIf="activeIndex === 'R_029'">
              <app-bulk-production
                [id]="stapName.id"
                [step]="stapName"
                [getUrl]="'revenue/final-offer/'"
                [postUrl]="'revenue/final-offer/'"
                (generatePDFEmitter)="generatePDF($event)"
                (stepCompleted)="goToNextStep()"
                (IRA)="onIRA($event)"
                [isEditable]="isEditable"
                [stepDetails]="step_details"
                [schemeType]="'rev'"
              ></app-bulk-production>
            </ng-container> -->
            <!-- <ng-container *ngIf="activeIndex === 'R_030'">
              <app-project-closure
                [stepDetails]="step_details" [schemeType]="'rev'"[urls]="{GPUrl:'/revenue/project/closure/'}" (routeConfig)="showConfirm()"
              ></app-project-closure>
            </ng-container> -->
          </div>
        </div>
      </div>
      <div *ngIf="userGuide == 'user'">
        <div class="ms-3 me-2 card p-2">
          <div class="card-body">
            <h4 class="mb-3"><strong>User Hierarchy</strong></h4>
            <p class="text-muted">People working on this project</p>

            <div
              class="d-flex align-items-center justify-content-between mb-3"
              *ngFor="let member of routeList"
            >
              <div class="d-flex align-items-center gap-2">
                <div class="icon-alert p-3 rounded-circle">
                  <i class="fa-regular fa-user fa-2x"></i>
                </div>
                <div>
                  <h5 class="mb-0 text-dark">{{ member.user.loginname }}</h5>
                  <h6 class="mb-0 text-dark">
                    {{ member.user.rankName }} {{ member.user.first_name }}
                    {{ member.user.last_name }}
                  </h6>
                  <small class="text-muted">{{ member.role?.name }}</small>
                </div>
              </div>
              <!-- <button class="btn  p-0">
										<i class="fa-regular fa-message fa-lg"></i>
									</button> -->
            </div>

            <!-- <button class="fetch-data-btn h-35px w-100 mt-3" (click)="editeRoute()">
									<i class="pi pi-users me-2"></i>
									Manage Route
								</button> -->
          </div>
        </div>
      </div>
      <div *ngIf="userGuide === 'comments'">
        <div class="card">
          <app-commenting-seet
            [id]="stapName.id"
            [stepDetails]="step_details"
          ></app-commenting-seet>
        </div>
      </div>
      <div class="card p-4" *ngIf="userGuide === 'report'">
        <div>
          <div class="d-flex justify-content-start">
            <h4>Reports & Documents</h4>
            <!-- <button class="btn btn-primary" (click)="onUserGuide('report');getReportList()">Refresh</button> -->
          </div>
          <hr />
          <div *ngIf="reportList.length > 0">
            <h5>Report Version</h5>
            <p-table
              class="mx-5 mb-4"
              [value]="reportList"
              [paginator]="reportList.length > 10"
              [rows]="10"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Version Name</th>
                  <th>Date</th>
                  <!-- <th>User</th> -->
                  <th>Action</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td>{{ item.name }}</td>
                  <td>{{ item.modified_on | date : "medium" }}</td>
                  <!-- <td>{{item.user}}</td> -->
                  <td (click)="pdfconvert(item.paragraph)">
                    <a class="view-link">View</a>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
          <div *ngIf="documentList.length > 0">
            <h5>Documents Available</h5>
            <p-table
              class="mx-5 mb-4"
              [value]="documentList"
              [paginator]="documentList.length > 10"
              [rows]="10"
            >
              <ng-template pTemplate="header">
                <tr>
                  <th>Document Name</th>
                  <th>View</th>
                  <th>Download</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr>
                  <td>{{ item.name }}</td>
                  <td>
                    <button
                      class="btn btn-sm btn-link"
                      (click)="viewDocument(item)"
                    >
                      <i class="pi pi-eye"></i>
                    </button>
                  </td>
                  <td>
                    <button
                      class="btn btn-sm btn-link"
                      (click)="downloadDocument(item)"
                    >
                      <i class="pi pi-download"></i>
                    </button>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <p-dialog
    header="Configure Route"
    [(visible)]="visible"
    [modal]="true"
    [resizable]="false"
    [closable]="true"
    appendTo="body"
    [style]="{ width: '800px' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true"
  >
    <div class="p-3">
      <div class="route-list-container">
        <div class="">
          <ng-container
            *ngIf="filteredRouteList?.length > 0; else emptyTemplate"
          >
            <div
              class="route-track"
              [class.single-item]="filteredRouteList.length === 1"
            >
              <div
                class="route-item"
                *ngFor="
                  let member of filteredRouteList;
                  let i = index;
                  let last = last
                "
              >
                <!-- Dot -->
                <div
                  class="step-dot"
                  [class.active-dot]="isInProgressPath(member, i)"
                  [class.inactive-dot]="!isInProgressPath(member, i)"
                ></div>

                <!-- Connector -->
                <div
                  class="step-connector"
                  [class.active-connector]="isConnectorActive(i)"
                  [class.inactive-connector]="!isConnectorActive(i)"
                  *ngIf="!last"
                ></div>

                <div class="user-info">
                  <span class="user-name">{{ member.user.loginname }}</span>
                  <span class="user-role">
                    {{ member.user.rankName }} {{ member.user.first_name }}
                    {{ member.user.last_name }} </span
                  ><br />
                  <span class="user-role"
                    >Designation : {{ member.user.hrcdf_designation }}</span
                  ><br />
                  <span class="user-role"
                    >Directorate : {{ member.user.unit.name }}</span
                  ><br />
                  <span class="user-role">Role : {{ member.role.name }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>

      <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
        <!-- <div class="row"> -->
        <!-- <div class="col-md-6 mb-3 ">
						<label>Steps</label>
						<p-dropdown [options]="stagesList" formControlName="step" optionValue="id" optionLabel="name"
							[filter]="true" filterBy="name" placeholder="Select a Stage" class="w-100"
							(onChange)="onStepChange($event)">
						</p-dropdown>
					</div> -->
        <div class="col-md-12 mb-3">
          <label>Role</label>
          <p-dropdown
            [options]="roleList"
            formControlName="role"
            optionValue="id"
            optionLabel="name"
            [filter]="true"
            filterBy="name"
            placeholder="Select a Role"
            class="w-100"
            (onChange)="onRoleChange($event)"
            appendTo="body"
          >
          </p-dropdown>
        </div>
        <!-- <div class="col-md-6 mb-3">
						<label>Directorate</label>
						<p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
							placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)"
							[filter]="true" filterBy="name" appendTo="body">
						</p-dropdown>
					</div> -->
        <div class="col-md-12 mb-3">
          <label>User</label>
          <p-dropdown
            [options]="userList"
            formControlName="user"
            optionValue="id"
            optionLabel="first_name"
            placeholder="Select a User"
            class="w-100"
            [filter]="true"
            filterBy="first_name"
            appendTo="body"
            (onChange)="onUserChange($event)"
          >
            <ng-template let-user pTemplate="item">
              <div class="list-group-item list-group-item-action col-md-6">
                <small>
                  {{ user.unit.name }} - {{ user.hrcdf_designation }}
                  {{ user.first_name }} {{ user.last_name }} -
                  {{ user.loginname }}</small
                >
              </div>
            </ng-template>
          </p-dropdown>
        </div>
        <!-- </div> -->
        <!-- <div class="col-md-6 mb-3 flex-col">
						<label for="menuIcon">Sequence</label>
						<input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
							class="w-100" />
					</div> -->
        <div class="mb-3 d-flex justify-content-end">
          <!-- <div class=" mb-3 ad-user">
							<p-checkbox formControlName="approved" binary="true" inputId="ad_user"
								class="custom-checkbox me-3"></p-checkbox>
							<label for="ad_user">Approve</label>
						</div> -->
          <!-- <div class=" footer-btn  mt-6"> -->
          <button
            pButton
            label="Submit"
            type="submit"
            class="fetch-data-btn"
            [disabled]="routeForm.invalid"
          ></button>
          <!-- </div> -->
        </div>
      </form>

      <!-- MAke it table here -->

      <!-- <div class="mt-4  mb-4">
				<ng-container *ngIf="proposalData?.length > 0">
					<app-data-table [columns]="route_cols" [data]="proposalData" title="User to Proposal Mapping"
						[showAddButton]="false" [isDeletable]="true"></app-data-table>
				</ng-container>
			</div> -->
    </div>
  </p-dialog>

  <p-dialog
    header="PDF View "
    [(visible)]="displayDialog"
    position="top"
    [draggable]="true"
    [resizable]="true"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [closable]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true"
  >
    <div class="p-3 mt-4">
      <div class="d-flex justify-content-between mb-3">
        <p-floatLabel
          variant="in"
          class="mt-2"
          *ngIf="
            step_details?.is_initiator ||
            step_details?.is_approver ||
            step_details?.is_recommender ||
            (step_details?.step_status != 'approved' && userID == 6)
          "
        >
          <input
            pInputText
            id="DocName"
            pSize="large"
            [(ngModel)]="DocName"
            autocomplete="off"
            class="w-100"
          />
          <label for="DocName">Document Name with Version </label>
        </p-floatLabel>
        <div class="d-flex gap-16">
          <button
            class="btn btn-primary"
            (click)="saveVersion()"
            *ngIf="
              step_details?.is_initiator ||
              step_details?.is_approver ||
              step_details?.is_recommender ||
              (step_details?.step_status != 'approved' && userID == 6)
            "
          >
            Save Version
          </button>
          <button
            class="btn btn-primary"
            [openNewTab]="true"
            printSectionId="printSection"
            ngxPrint
            styleSheetFile="assets/pdfcss.css"
          >
            Download PDF
          </button>
        </div>
      </div>
      <div id="printSection" class="table-bordered">
        <table class="table table-bordered">
          <tr>
            <td colspan="2" class="border font-weight-bold p-2">
              <h4 class="text-center">{{ stapName?.name }}</h4>
            </td>
          </tr>
          <tr *ngFor="let item of pdfdata?.data">
            <ng-container *ngIf="isHTMLorText(item.value)">
              <td colspan="2" class="font-weight-bold p-2">
                <h4>{{ item.key }}</h4>
                <span [innerHTML]="item.value"></span>
              </td>
            </ng-container>
            <ng-container *ngIf="!isHTMLorText(item.value)">
              <td class="border font-weight-bold p-2">{{ item.key }}</td>
              <td class="border p-2">{{ item.value }}</td>
            </ng-container>
          </tr>
        </table>
      </div>
    </div>
  </p-dialog>
  <p-dialog
    header="{{
      IRA === 'Initiate'
        ? 'Initiator'
        : IRA === 'Recommend'
        ? 'Recommender'
        : 'Approver'
    }}"
    [(visible)]="isIRA"
    position="top"
    [draggable]="true"
    [resizable]="true"
    [modal]="true"
    [style]="{ width: '50vw' }"
    [closable]="true"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
    [maximizable]="true"
  >
    <div class="card-body mt-3">
      <div class="mt-3">
        <div class="card-header">
          <h5 class="mb-0">
            {{
              IRA === "Initiate"
                ? "Initiator"
                : IRA === "Recommend"
                ? "Recommender"
                : "Approver"
            }}
            Remarks
          </h5>
        </div>
        <p-floatLabel variant="in" class="mt-2 w-100">
          <textarea
            pInputTextarea
            id="DocName"
            rows="10"
            [(ngModel)]="IRAremarks"
            autocomplete="off"
            class="w-100"
          ></textarea>
          <!-- <label for="DocName">Comments</label> -->
        </p-floatLabel>
      </div>
      <div *ngIf="step_details?.add_route_conf">
        <h5 class="mb-2 mt-2">Add Member to the next route.</h5>
        <form [formGroup]="routeForm" (ngSubmit)="onrouteFormSubmit()">
          <div class="row">
            <!-- <div class="col-md-6 mb-3 ">
						<label>Steps</label>
						<p-dropdown [options]="stagesList" formControlName="step" optionValue="id" optionLabel="name"
							[filter]="true" filterBy="name" placeholder="Select a Stage" class="w-100"
							(onChange)="onStepChange($event)">
						</p-dropdown>
					</div> -->
            <div class="col-md-12 mb-3">
              <label>Role</label>
              <p-dropdown
                [options]="roleList"
                formControlName="role"
                optionValue="id"
                optionLabel="name"
                [filter]="true"
                filterBy="name"
                placeholder="Select a Role"
                class="w-100"
                (onChange)="onRoleChange($event)"
                appendTo="body"
              >
              </p-dropdown>
            </div>
            <!-- <div class="col-md-6 mb-3">
							<label>Directorate</label>
							<p-dropdown [options]="unitList" formControlName="unit" optionValue="id" optionLabel="name"
								placeholder="Select a Directorate" class="w-100" (onChange)="onUnitChange($event)"
								[filter]="true" filterBy="name" appendTo="body">
							</p-dropdown>
						</div> -->
            <div class="col-md-12 mb-3">
              <label>User</label>
              <p-dropdown
                [options]="userList"
                formControlName="user"
                optionValue="id"
                optionLabel="first_name"
                placeholder="Select a User"
                class="w-100"
                [filter]="true"
                filterBy="first_name"
                appendTo="body"
                (onChange)="onUserChange($event)"
              >
                <ng-template let-user pTemplate="item">
                  <div class="list-group-item list-group-item-action">
                    <small>
                      {{ user.unit.name }} - {{ user.hrcdf_designation }}
                      {{ user.first_name }} {{ user.last_name }} -
                      {{ user.loginname }}</small
                    >
                  </div>
                </ng-template>
              </p-dropdown>
            </div>
            <!-- <div class="col-md-6 mb-3 flex-col">
						<label for="menuIcon">Sequence</label>
						<input id="menuIcon" type="text" pInputText formControlName="level" placeholder="Enter Sequence"
							class="w-100" />
					</div> -->
            <div class="col-md-12 mb-3 d-flex justify-content-end">
              <!-- <div class=" mb-3 ad-user">
							<p-checkbox formControlName="approved" binary="true" inputId="ad_user"
								class="custom-checkbox me-3"></p-checkbox>
							<label for="ad_user">Approve</label>
						</div> -->
              <!-- <div class=" footer-btn  mt-6">
								<button pButton label="Submit" type="submit" class="fetch-data-btn"></button>
							</div> -->
            </div>
          </div>
        </form>
      </div>

      <div class="card-footer text-end gap-3">
        <button
          pButton
          label="Reject"
          *ngIf="IRA !== 'Initiate'"
          type="submit"
          icon="pi pi-times"
          class="p-button-danger me-4 reject-btn"
          (click)="submitIRA(false)"
        ></button>
        <button
          pButton
          label="{{ IRA }} and Send"
          type="submit"
          icon="pi pi-check"
          class="p-button-success initiate-btn"
          (click)="submitIRA(true)"
          *ngIf="step_details?.add_route_conf"
        ></button>
        <button
          pButton
          label="{{ IRA }}"
          type="submit"
          icon="pi pi-check"
          class="p-button-success initiate-btn"
          (click)="submitIRA(true)"
          *ngIf="!step_details?.add_route_conf"
        ></button>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    header="View Signatures"
    [(visible)]="viewSignVisible"
    [modal]="true"
    [closable]="true"
    [maximizable]="true"
    [style]="{ width: '700px' }"
  >
    <div>
      <div class="card p-3 my-3" id="comments-pdf">
        <h2>Digital Signatures</h2>

        <div
          *ngFor="let comment of signData"
          class="comment-card mb-3 p-3 shadow-sm"
        >
          <div class="d-flex align-items-start">
            <!-- Avatar -->
            <div
              class="avatar bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3"
            >
              {{
                getInitials(
                  comment.user?.first_name + " " + comment.user?.last_name
                )
              }}
            </div>

            <!-- Content -->
            <div class="flex-grow-1">
              <h6 class="mb-0">
                {{ comment.user?.first_name }} {{ comment.user?.last_name }}
              </h6>
              <small class="text-muted">
                {{ comment.created_on | date : "MMMM d, y, h:mm a" }} <br />
              </small>
              <!-- <p class="mt-2 mb-1">{{ comment.comment }}</p> -->
              <small class="text-muted"
                ><i class="pi pi-check-circle"></i> Digitally signed &
                verified</small
              >
            </div>

            <!-- Digital Signature (QR Code) -->
            <div class="ms-3 text-center">
              <qrcode
                [qrdata]="getQRData(comment)"
                [width]="100"
                [errorCorrectionLevel]="'M'"
              >
              </qrcode>
              <small class="text-muted d-block mt-1"
                >Digital<br />Signature</small
              >
            </div>
          </div>
          <!-- <div class="text-muted mt-2">ID: #{{ comment.id }}</div> -->
        </div>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    header="Share Proposal"
    [(visible)]="displayDialogN"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [style]="{ width: '65vw' }"
    appendTo="body"
    contentStyle="overflow: visible"
  >
    <div class="p-fluid">
      <!-- Step 1: Choose type -->
      <div class="mb-4 mt-3">
        <h6 class="mb-2">Share With:</h6>
        <div class="d-flex gap-4 align-items-center">
          <p-radioButton
            name="shareType"
            value="internal"
            label="Internal"
            [(ngModel)]="shareType"
          ></p-radioButton>
          <p-radioButton
            name="shareType"
            value="external"
            label="External"
            [(ngModel)]="shareType"
          ></p-radioButton>
        </div>
      </div>

    <!-- Internal Section -->
    <div *ngIf="shareType === 'internal'" class="mb-4">
      <div class="d-flex gap-4 flex-wrap align-items-start">
        <!-- User Dropdown -->
        <div class="flex-grow-1">
          <label for="userSelect" class="mb-2 d-block">Select User</label>
          <p-dropdown 
            id="userSelect"
            [options]="userListN" 
            optionLabel="first_name" 
            [(ngModel)]="selectedUserN"
            placeholder="Choose a user" 
            appendTo="body" 
            class="w-100">
			<ng-template let-user pTemplate="item">
                        <div class="list-group-item list-group-item-action col-md-6">
                          <small> {{user.hrcdf_designation}} {{ user.first_name }} {{ user.last_name }} - {{ user.loginname }}</small>
                        </div>
                    </ng-template>
          </p-dropdown>
        </div>

          <!-- Permission Type -->
          <div class="flex-grow-1">
            <label class="mb-2 d-block">Permission Type</label>
            <div class="d-flex gap-3 flex-wrap">
              <p-radioButton
                name="permission"
                value="edit"
                label="Edit"
                [(ngModel)]="permissionType"
              ></p-radioButton>
              <p-radioButton
                name="permission"
                value="view"
                label="View"
                [(ngModel)]="permissionType"
              ></p-radioButton>
              <p-radioButton
                name="permission"
                value="comment"
                label="Comment"
                [(ngModel)]="permissionType"
              ></p-radioButton>
            </div>
          </div>
        </div>

        <!-- Comment Section -->
        <div class="mt-3">
          <label for="internalComment" class="mb-2 d-block"
            >Comment (optional)</label
          >
          <textarea
            id="internalComment"
            class="form-control w-100"
            rows="3"
            [(ngModel)]="internalComment"
            placeholder="Enter your comment here..."
          ></textarea>
        </div>
      </div>

      <!-- External Section -->
      <div *ngIf="shareType === 'external'" class="mb-4">
        <div class="mb-3">
          <label for="unitSelect" class="mb-2 d-block">Select Unit</label>
          <p-dropdown
            id="unitSelect"
            [options]="unitListN"
            optionLabel="name"
            [(ngModel)]="selectedUnit"
            placeholder="Choose a unit"
            appendTo="body"
            class="w-100"
          >
          </p-dropdown>
        </div>

        <!-- Comment Section -->
        <div>
          <label for="externalComment" class="mb-2 d-block"
            >Comment (optional)</label
          >
          <textarea
            id="externalComment"
            class="form-control w-100"
            rows="3"
            [(ngModel)]="externalComment"
            placeholder="Enter your comment here..."
          ></textarea>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <ng-template pTemplate="footer">
      <button
        (click)="saveSelection()"
        class="fetch-data-btn p-button p-button-sm p-button-primary"
      >
        Save
      </button>
      <!-- <button 
      (click)="displayDialogN = false" 
      class="p-button-secondary p-button p-button-sm"> Cancel
    </button> -->
    </ng-template>
  </p-dialog>
</div>
